import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { XStack, YStack } from '@/components/ui';
import { getSearchActionSubtitle } from '@/features/cmd-bar/search-result-presentation';

import {
  type ChatSearchResult,
  getSearchResultThreadId,
} from './all-chats.types';
import { SelectableChatRow } from './SelectableChatRow';

import type { MouseEvent } from 'react';

export const ChatSearchResultRow = observer(function ChatSearchResultRow({
  item,
  query,
  isSelected,
  selectionActive,
  onToggleSelect,
  onOpen,
}: {
  item: ChatSearchResult;
  query: string;
  isSelected: boolean;
  selectionActive: boolean;
  onToggleSelect: (id: string) => void;
  onOpen: (item: ChatSearchResult, event?: MouseEvent) => void;
}) {
  const threadId = getSearchResultThreadId(item);

  return (
    <SelectableChatRow
      id={threadId}
      label={item.title}
      isSelected={isSelected}
      selectionActive={selectionActive}
      onToggleSelect={onToggleSelect}
      onOpen={(event) => onOpen(item, event)}
    >
      <YStack className="min-w-0 flex-1 gap-0.5">
        <XStack className="items-center gap-3">
          {item.type === 'message' ? (
            <Icons.messageSearch className="size-4 shrink-0 text-foreground-muted" />
          ) : (
            <Icons.chat className="size-4 shrink-0 text-foreground-muted" />
          )}
          <p className="min-w-0 truncate text-foreground">{item.title}</p>
        </XStack>
        {item.type === 'message' && (
          <span className="min-w-0 truncate pl-7">
            {getSearchActionSubtitle(item.content, query)}
          </span>
        )}
      </YStack>
    </SelectableChatRow>
  );
});
